import { isEqual } from 'lodash-es'
import { useEffect } from 'react'
import {
  AppStatus,
  DraftSession,
  IEvent,
  IFacility,
  IWorkspace,
  TemplateDocs,
  TemplateRoute,
} from 'types'
import { useLocalStorage } from 'usehooks-ts'
import { useDoc, usePreference } from 'utils'

export interface ExplorerCache {
  workspace?: IWorkspace
  event?: IEvent
  facility?: IFacility
  templateDocs?: TemplateDocs
}

export const useExplorerCache = () => usePreference<ExplorerCache | null>('explorer-cache', null, 1)

export const useCachedFacility = () => usePreference<IFacility | null>('facility', null, 0)

export type TemplateSource = 'standalone' | 'facility'

export const useSource = () => useLocalStorage<TemplateSource>('template-source', 'facility')

export function useCachedWorkspace(id?: string | null) {
  const [data, setter] = usePreference<IWorkspace | null>('workspace', null, 0)
  const [latestData] = useDoc('Workspace', id || (id === null ? undefined : id || data?.id))

  useEffect(() => {
    if (latestData !== undefined && !isEqual(latestData, data)) setter(latestData)
  }, [latestData])

  return [data, setter] as const
}

export interface ExplorerSessionCache {
  status?: AppStatus
  routeSteps?: TemplateRoute[]
  session?: DraftSession
}

export const useExplorerSessionCache = () =>
  usePreference<ExplorerSessionCache | null>('explorer-session-cache', null, 0)
